import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { withRouter } from "react-router-dom";
import "./HomeFlat.css";
import Logo from "../assets/images/logo.png";
import langFa from "../assets/images/iran.png";
import langEn from "../assets/images/eng.svg";
import langKu from "../assets/images/kurd.png";
import langTajik from "../assets/images/tajik.png";
import { ModalComp } from "../shared";
import { TermsAndConditions, PrivacyPolicy } from "./";
import i18n from "../i18n/locales/config";
import { useTranslation } from "react-i18next";
import { ThemeLanguageToggle } from "./Auth/Login/ThemeLanguageToggle";

const HomeComp = (props) => {
  const [showHome, setShowHome] = useState(false);
  const [openTermsModal, setOpenTermsModal] = useState(false);
  const toggleTerms = () => setOpenTermsModal(!openTermsModal);
  const [openPrivacyModal, setOpenPrivacyModal] = useState(false);
  const togglePrivacy = () => setOpenPrivacyModal(!openPrivacyModal);
  const { t } = useTranslation();
  useEffect(() => {
    if (Cookies.get("token")) {
      setShowHome(false);
      props.history.push("/panel");
    } else {
      setShowHome(true);
    }
  }, []);
  const [language, setLanguage] = useState(
    Cookies.get("language") ? Cookies.get("language") : "en"
  );
  const handleEnLan = () => {
    setLanguage("en");
    Cookies.set("language", "en");
  };
  const handleFaLan = () => {
    setLanguage("fa");
    Cookies.set("language", "fa");
  };
  const handleKuLan = () => {
    setLanguage("ku");
    Cookies.set("language", "ku");
  };
  useEffect(() => {
    const lan = Cookies.get("language") ? Cookies.get("language") : "en";
    i18n.changeLanguage(lan);
    lan === "en"
      ? document.querySelector("body").classList.add("dirLTR")
      : document.querySelector("body").classList.remove("dirLTR");
  }, [language]);

  return (
    <>
      <ModalComp
        modal={openTermsModal}
        toggle={toggleTerms}
        component={<TermsAndConditions />}
      />
      <ModalComp
        modal={openPrivacyModal}
        toggle={togglePrivacy}
        component={<PrivacyPolicy />}
      />

      {showHome && (
        <div className="home-flat-container">
          {/* Theme and Language Controls */}
          <ThemeLanguageToggle 
            onLanguageChange={(lang) => {
              if (lang === 'fa') handleFaLan();
              else if (lang === 'en') handleEnLan();
              else if (lang === 'ku') handleKuLan();
            }}
          />
          
          <div className="home-flat-card">
            {/* Logo Section */}
            <div className="home-flat-logo-wrapper">
              <div className="home-flat-logo">
                <img src={Logo} alt="Logo" />
              </div>
            </div>
            
            {/* Header Section */}
            <div className="home-flat-header">
              <h2 className="home-flat-title">{t("هاب هوشمند ماندگار مدار آوین")}</h2>
              <p className="home-flat-subtitle">{t("از خانه خود لذت ببرید")}</p>
            </div>
            
            {/* Buttons Section */}
            <div className="home-flat-buttons">
              <button
                className="home-flat-button home-flat-button-primary"
                onClick={() => props.history.push("/login")}
              >
                {t("ورود")}
              </button>
              <button
                className="home-flat-button home-flat-button-secondary"
                onClick={() => props.history.push("/register")}
              >
                {t("ثبت نام")}
              </button>
            </div>
            
            {/* Footer Links */}
            {/* <div className="home-flat-footer">
              {/* <a className="mx-2" onClick={toggleTerms}>
                {t("شرایط و قوانین")}
              </a> */}
              {/* | */}
              {/* <a className="mx-2" onClick={togglePrivacy}>
                {t("حریم خصوصی")}
              </a> */}
            {/* </div> */}
          </div>
        </div>
      )}
    </>
  );
};

const Home = withRouter(HomeComp);

export { Home };
